<template lang="html">

  <section class="ficha-proyecto">

    <div class="wrapper margin-menu" v-if="!!data">

      <section class="intro column-center -agua-para-todos">
        <h2>Agua para todos</h2>
        <h1>{{data.name}}</h1>
      </section>

      <section class="breadcrumb">
        <nav class="container row-end">
          <router-link to="/">Inicio</router-link>
          <router-link :to="$t('enlaces.aguaparatodos')">Agua para todos</router-link>
          <router-link :to="$t('enlaces.proyectosencurso')">Proyectos en curso</router-link>
          <router-link :to="$t('enlaces.proyecto')+'/'+data.slug">{{data.name}}</router-link>
        </nav>
      </section>

      <main>


        <section class="container">

          <h2 class="title-intro row-center">
            <img src="/static/img/logo-agua-para-todos.png" alt="Logo agua para todos">
          </h2>

        </section>

        <section class="intro-proyecto-container column-start">
          <div class="intro-proyecto container row-start ais">

            <h2 class="big-title left -dark">{{data.country}} {{data.start_year}}</h2>

            <div class="imagen">
              <img :src="data.image.url" :alt="data.name">
            </div>

            <div class="contenedor-claim-donacion">
              <div class="claim-donacion">
                <h2>¿Nos ayudas?</h2>
                <div class="row-center">
                  <h3>Ya hemos conseguido un <strong>{{percent}}%</strong></h3>
                  <div class="imagenes row-center">
                    <gota :width="61" :height="90" :percent="percent"></gota>
                    <img src="/static/img/pozo-financiacion.svg" alt="Pozo">
                  </div>
                </div>
                <a @click="toPayment" class="btn skull-white" v-if="data.complete == 0">Quiero colaborar</a>
                <img src="/static/img/corazon.svg" alt="Corazón" class="corazon">
              </div>
            </div>

            <div class="texto">
              <h2 class="title-intro no-line">
                Sobre el <strong>Proyecto</strong>
              </h2>
              <p v-html="data.description"></p>
            </div>
          </div>

        </section>

        <section class="objetivos container row-between ais">
          <article>
            <h2 class="big-title">Objetivo</h2>
            <p>{{data.objective}}</p>
          </article>
          <article class="alcance">
            <h2 class="big-title">Alcance</h2>
            <p class="column-center"><strong class="personas">{{data.persons_helped}}</strong> Personas</p>
            <img src="/static/img/background-personas.svg" class="background-personas">
          </article>
          <article class="donde">
            <h2 class="big-title">Dónde</h2>
            <p>{{data.city}}, {{data.country}}</p>
          </article>
          <article class="ayuda">
            <h2 class="big-title">Ayuda</h2>
            <p>{{data.help}}</p>
            <img src="/static/img/manos-ayuda.svg" class="manos-ayuda">
          </article>
        </section>

        <section class="ficha-noticia container">

          <div class="container contenedor-noticia">

            <editor-js :object="data.body" />

          </div>

        </section>


        <div class="slider-wrapper" v-if="data.galery">
          <div class="big-title container left">Proyecto</div>
          <slide :gallery="data.galery" v-if="data.galery"></slide>
        </div>


        <section class="colabora-project" v-if="data.complete == 0">
          <div class="container colabora-title">
            <h2 class="big-title">Colabora</h2>
            <h3 class="title-intro no-line">¿Te animas a <strong>colaborar</strong>?</h3>

            <h3 class="title-intro small">
              Con tu donativo podremos seguir acercando el agua a <strong>aquellos que más lo necesitan</strong>
            </h3>
          </div>

          <div class="payment-container" v-if="data.complete == 0">
            <payment :id="data.id"></payment>
          </div>


        </section>


      </main>

    </div>

    <div class="loading-view column-center" v-else>
      <img src="/static/img/logo-fundacion-gris.svg" alt="imagen logo fundacion">
      <img src="/static/img/loading-red.svg" alt="imagen loading">
    </div>

  </section>

</template>

<script lang="js">

  import { mapGetters, mapActions } from 'vuex'

  import payment from '@/components/parts/payment'

  import slide from '@/components/parts/slide';

  import gota from '@/components/parts/gota';

  import editorJs from '@/components/editorJs';

  export default {
    name: 'ficha-proyecto',
    created() {
      this.getProject();
    },
    data() {
      return {
        data: ''
      }
    },
    methods: {
      ...mapActions(['requestProject']),
      getProject() {
        this.requestProject(this.$route.params.id)
          .then((result) => {
            this.data = result;

            if (this.$route.hash.includes("#donar")) {
              setTimeout(e => {
                this.toPayment();
              }, 500)
            }

          })
      },
      toPayment() {
        $("html,body").animate({ scrollTop: $(".colabora-project").position().top - 150 }, '500');
      }
    },
    components: {
      'payment': payment,
      'slide': slide,
      'gota': gota,
      'editor-js': editorJs
    },
    computed: {
      percent() {
        if(this.data.complete === 1) {
          return 100;
        }
        /* return (100 * this.data.total / this.data.money_needed).toFixed(2); */
        return this.data.per;
      }
    },
    watch: {
      '$route'() {
        this.getProject();
      }
    }
  }
</script>

<style scoped lang="scss">
  .ficha-noticia {}
</style>


// WEBPACK FOOTER //
// src/components/views/project-view.vue